


































import { defineComponent, PropType, ref } from "@vue/composition-api";
import { CreatorService } from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import BaseButton from "@/components/BaseButton";
import CreatorServiceListModal from "./CreatorServiceListModal.vue";
import CreatorServiceRemoveConfirm from "./CreatorServiceRemoveConfirm.vue";

export default defineComponent({
  name: "CreatorServiceList",
  components: {
    BaseButton,
    CreatorServiceListModal,
    CreatorServiceRemoveConfirm,
  },
  props: {
    title: { type: String, required: true },
    items: { type: Array as PropType<CreatorService[]>, required: true },
    enableScroll: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    selectedFilter: { type: String, default: "" },
  },
  setup(_, { emit }) {
    const serviceToDelete = ref<CreatorService | null>(null);

    const onRemoveConfirm = (done: () => void) => {
      if (!serviceToDelete.value) return;
      emit("remove", serviceToDelete.value.id, () => {
        done();
        serviceToDelete.value = null;
      });
    };

    return {
      serviceToDelete,
      onRemoveConfirm,
    };
  },
});
